import request from '@/axios'
import type { UserLoginType } from './types'

export const loginApi = (data: UserLoginType) => {
  return request.post({ url: '/login', data })
}

// 获取登录用户信息
export const getInfoApi = () => {
  return request.get({ url: '/getInfo' })
}

// 获取路由信息
export const getRoutersApi = (): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/getRouters' })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/logout' })
}
